<script setup lang="ts">
  import GlobalAiChat from '@/components/app/chat/global/GlobalAiChat.vue'
  import { useGlobalChatStore } from '@/store/app/globalChat/globalChatStore'
  import { AIChatSessionTypeEnum } from '@/types/generated'
  import { computed, onMounted, provide, ref } from 'vue'
  import { useRoute } from 'vue-router'

  const route = useRoute()
  const globalChatStore = useGlobalChatStore()

  // State
  const activeFolderId = ref<string | null>(null)

  // Computed
  const activeSessionGroup = computed(() => {
    if (!activeFolderId.value) return null
    return (
      globalChatStore.sessionGroups.find((group) => group.uuid === activeFolderId.value) || null
    )
  })

  // Provide global context to child components
  provide('sessionType', AIChatSessionTypeEnum.GLOBAL)
  provide('sessionGroupData', activeSessionGroup)

  // Initialize
  onMounted(async () => {
    // Load session groups
    await globalChatStore.loadSessionGroups()

    // Load global prompt templates
    await globalChatStore.loadGlobalPromptTemplates()

    // Load standalone global chat sessions
    await globalChatStore.loadStandaloneGlobalChatSessions()

    // Set active folder from route params
    const groupUuid = route.params.groupUuid as string
    if (groupUuid) {
      activeFolderId.value = groupUuid
      // Load chat sessions for this folder
      await globalChatStore.loadChatSessions(groupUuid)
    }
  })
</script>

<template>
  <div class="flex h-[calc(100vh-60px)] w-full">
    <!-- Global AI Chat with integrated sidebar -->
    <GlobalAiChat
      :session-group-uuid="activeFolderId || undefined"
      :session-group="activeSessionGroup || undefined"
    />
  </div>
</template>
